<template>
    <div>
        <section v-if="appParams && appParams.staticTranslations" class="itb-references-alike-set mt-2">
            <div class="container">
                <div class="row mt-3 mb-3">
                    <div class="col-12">
                        <p class="pt-4 pb-4 itb-inspirations-intro-text px-3">
                            {{
                                appParams.staticTranslations[
                                "inspirations.intro_text"
                                ]
                            }}
                        </p>

                        <div
                            class="d-flex align-items-center flex-wrap justify-content-center mt-4 mb-3 itb-filter-options">
                            <span class="mr-4">
                                {{ appParams.staticTranslations["graphics.tags"] }}:
                            </span>

                            <div v-for="hashtag in inspirationHashtags" class="itb-hashtags d-flex align-items-center">
                                <label class="itb-checkbox-label ml-auto">
                                    <input type="checkbox" v-model="filters.hashtags" :value="hashtag.id"
                                        @change="reloadInspirations" />
                                    <span class="itb-checkbox"></span>
                                </label>
                                <span class="ml-1 mr-3 itb-hashtag-name">
                                    {{ hashtag.name }}
                                </span>
                            </div>
                            <button class="btn btn-danger btn-sm my-0 ml-5" style="box-shadow: none"
                                @click="cleanFilters">
                                <img class="mr-2" src="/images/close-white.svg" width="7" />
                                {{ appParams.staticTranslations["graphics.clean_filters"] }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <Tinybox v-model="index" :images="inspirations ? inspirations : []"></Tinybox>

                    <div class="col-12 col-md-4 TESTTTT" v-for="(image, idx) in inspirations" :key="idx">
                        <div class="card w-100 itb-margin-bottom itb-lazy-loading-bg open-tinybox" @click="index = idx"
                            v-lazy:background-image="image
                                ? '/uploads/' +
                                image.path +
                                '/' +
                                'sm_' +
                                image.name
                                : null
                                " :title="image.description">
                            <div class="card-body d-flex p-0">
                                <div v-if="image.description" class="itb-text align-self-end w-100"
                                    style="padding: 1rem 0">
                                    <h4 class="mb-0">
                                        {{ image.description }}
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Tinybox from "vue-tinybox";

export default {
    data() {
        return {
            index: null,
            inspirations: [],
            pageParams: [],
            inspirationHashtags: [],
            filters: { hashtags: [] },
            defaultFilters: { hashtags: [] },
            query: {},
        };
    },

    components: {
        Tinybox,
    },

    mounted() {
        this.getData();
    },

    created() {
        this.goToInspirations();
        this.getInspirationHashtags();
    },

    computed: {
        ...mapGetters({
            appParams: "getAppParams",
            isLoggedIn: "getClientLogged",
            profile: "getClientProfile",
        }),
    },

    filters: {
        truncate: function (data, num) {
            const reqdString = data.split("").slice(0, num).join("");
            return reqdString + "…";
        },
    },

    methods: {
        ...mapActions(["setPageParams", "setFormParams"]),

        viewInspiration(id, alias) {
            this.$router.push(this.$route.path + "/" + id + "-" + alias);
        },
        goToInspirations() {
            var scrollCounter = 0;
            if (this.$route.hash == "#itb-h2-inspirations") {
                while (!!this.$refs.inspirations && scrollCounter < 0) {
                    this.$refs.inspirations.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                    scrollCounter = scrollCounter + 1;
                }
            }
        },

        getData() {
            if (this.$route.query.ht) {
                this.filters.hashtags = this.$route.query.ht.split(",").map(Number);
            }

            axios
                .post("/getInspirationsPage", this.filters)
                .then((response) => {
                    this.inspirations = response.data.inspirations;
                    this.pageParams = response.data.params;
                    this.setPageParams(this.pageParams);
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        async getInspirationHashtags() {
            await axios
                .get("/get-frontend-inspiration-hashtags")
                .then((response) => {
                    this.inspirationHashtags = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        cleanFilters() {
            this.filters = structuredClone(this.defaultFilters);
            this.reloadInspirations();
        },

        async reloadInspirations() {
            let query = {};
            if (this.filters.hashtags.length) {
                query["ht"] = this.filters.hashtags.join(",");
            } else {
                query["ht"] = [];
            }

            this.$router
                .push({
                    name: "inspirations",
                    params: {
                        savedPosition: true,
                    },
                    query: query,
                })
                .catch((err) => { });

            await axios
                .post("/get-frontend-inspirations", this.filters)
                .then((response) => {
                    this.inspirations = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>
